import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../CSS/Courses.css';
import TopperCard from './TopperCard';
import { getAllToppers } from '../firebase/firestoreService';

const CoursesCommerce = () => {
  const [toppers, setToppers] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getAllToppers()
      .then(data => setToppers(data.filter(t => t.course === 'Commerce')))
      .catch(() => {});
  }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Course",
        "name": "Commerce Classes 11th 12th — Ulhasnagar & Kalyan",
        "description": "Best commerce coaching for Class 11 and 12 in Ulhasnagar and Kalyan. Accounts, Economics, Business Studies. HSC board and competitive exam preparation at NGT.",
        "provider": { "@type": "EducationalOrganization", "name": "Nalanda Group Tuitions", "url": "https://nalandagrouptuitions.com" }
      }) }} />

      <div className="ngt-page-banner">
        <h1>Best Commerce Classes for 11th &amp; 12th in Ulhasnagar &amp; Kalyan</h1>
        <p>Accounts · Economics · Business Studies · HSC Board · Nalanda Group Tuitions</p>
      </div>

      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item">Courses</li>
          <li className="breadcrumb-item active">Commerce Classes 11th 12th Ulhasnagar</li>
        </ol>
      </nav>

      <section className="ngt-course-detail-page">
        <div className="container">
          <div className="row g-5 align-items-start">
            <div className="col-lg-8">
              <div className="ngt-card">
                <h2 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1rem' }}>
                  Commerce Coaching — Class 11 &amp; 12 (Ulhasnagar &amp; Kalyan)
                </h2>
                <p style={{ color: 'var(--ngt-grey)' }}>
                  NGT's <strong>commerce coaching for Class 11 and 12</strong> offers comprehensive guidance
                  in Accountancy, Economics, Business Studies, and Mathematics (OC). Our commerce faculty
                  combine HSC board preparation with practical knowledge of commerce concepts, helping
                  students score high in HSC examinations and build a strong foundation for CA, CS, MBA
                  and other professional careers.
                </p>
                <hr className="ngt-divider" />
                <h3 style={{ color: 'var(--ngt-navy)', fontSize: '1.1rem', marginBottom: '0.8rem' }}>Subjects Covered</h3>
                <ul style={{ color: 'var(--ngt-grey)', paddingLeft: '1.4rem', lineHeight: '2' }}>
                  <li><strong>Accountancy</strong> — Financial Accounting, Company Accounts, Partnership</li>
                  <li><strong>Economics</strong> — Micro &amp; Macro Economics, Indian Economy</li>
                  <li><strong>Business Studies</strong> — Management, Marketing, Finance</li>
                  <li><strong>Mathematics &amp; Statistics (OC)</strong> — Commerce Maths</li>
                  <li>HSC Board exam preparation with previous year papers</li>
                  <li>Career guidance for CA, CS, BMS, BAF, and MBA aspirants</li>
                </ul>
                <hr className="ngt-divider" />
                <h3 style={{ color: 'var(--ngt-navy)', fontSize: '1.1rem', marginBottom: '0.8rem' }}>Class Schedule</h3>
                <p style={{ color: 'var(--ngt-grey)' }}>
                  Monday through Saturday. Contact us for current batch availability at both branches.
                </p>
                <hr className="ngt-divider" />
                <div className="ngt-course-seo-block">
                  <h3>Best Commerce Classes in Ulhasnagar &amp; Kalyan</h3>
                  <p>
                    Searching for the <strong>best commerce classes for 11th and 12th in Ulhasnagar</strong>
                    or Kalyan? NGT is your answer. Our commerce programme has produced consistent HSC toppers
                    and students who have gone on to pursue CA, CS, BMS, and MBA at top colleges. With
                    dedicated Accountancy and Economics specialists, small batch sizes, and regular
                    assessments, NGT provides the most focused <strong>commerce coaching near Kalyan</strong> in Thane district.
                  </p>
                  <div className="ngt-course-links" style={{ marginTop: '1rem' }}>
                    <span style={{ fontSize: '0.88rem', color: 'var(--ngt-grey)' }}>Also explore: </span>
                    <Link to="/ssc-coaching-ulhasnagar-kalyan">SSC Coaching</Link> ·{' '}
                    <Link to="/cbse-coaching-ulhasnagar-kalyan">CBSE Coaching</Link> ·{' '}
                    <Link to="/science-coaching-ulhasnagar-kalyan">JEE / NEET Coaching</Link>
                  </div>
                </div>
              </div>

              {/* ── Commerce Toppers ── */}
              {toppers.length > 0 && (
                <div className="ngt-card mt-4">
                  <h3 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1.2rem' }}>
                    <i className="fas fa-trophy me-2" style={{ color: '#b8860b' }}></i>Commerce Toppers
                  </h3>
                  <div className="topper-scroll">
                    {toppers.map((t, i) => <TopperCard key={t.id || i} topper={t} />)}
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-4">
              <div className="ngt-enquiry-info">
                <h4>Enquire About Commerce Classes</h4>
                <p style={{ opacity: 0.85, fontSize: '0.92rem', marginBottom: '1.5rem' }}>
                  Ask about commerce batch timings, fees, and admissions for Class 11 and 12.
                </p>
                <Link to="/enquiry" className="btn-ngt-gold d-block text-center" style={{ marginBottom: '1rem' }}>Submit an Enquiry</Link>
                <a href="tel:+919272136659" className="btn-ngt-outline d-block text-center" style={{ color: '#fff', borderColor: '#fff' }}>
                  <i className="fas fa-phone me-1"></i> Call +91 9272136659
                </a>
                <hr style={{ borderColor: 'rgba(255,255,255,0.15)', margin: '1.5rem 0' }} />
                <div style={{ fontSize: '0.88rem', opacity: 0.8 }}>
                  <p><i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--ngt-gold)' }}></i>Century Branch — Murbad Road, Ulhasnagar</p>
                  <p><i className="fas fa-map-marker-alt me-2" style={{ color: 'var(--ngt-gold)' }}></i>Khemani Branch, Ulhasnagar</p>
                  <p><i className="fas fa-clock me-2" style={{ color: 'var(--ngt-gold)' }}></i>Mon – Sat · 7:00 AM – 8:00 PM</p>
                  <p><i className="fas fa-envelope me-2" style={{ color: 'var(--ngt-gold)' }}></i>ngt.mailer@gmail.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoursesCommerce;